import { Request } from "@konv/http";
import { EnvironmentStorage } from "../shared/tools/EnvironmentStorage";
import { UserStorage } from "../shared/tools/UserStorage";
import axios from "axios";

export class CatalogAPI {
  static async request({
    service = "catalog",
    endpoint = "/",
    method = "GET",
    headers,
    query,
    data,
  }) {
    return await Request.request({
      endpoint: endpoint,
      method: method,
      headers: headers,
      service: service,
      ignoreVersion: true,
      params: query,
      data: data,
      timeout: 0,
    });
  }

  static async requestAuthenticated({
    service = "catalog",
    endpoint = "/",
    method = "GET",
    query,
    data,
  }) {
    return await CatalogAPI.request({
      service,
      endpoint,
      headers: { Authorization: "Bearer " + UserStorage.getAccessToken() },
      method,
      query,
      data,
    });
  }

  static async getIfoodCatalog(environmentId, service) {
    const environment =
      environmentId || EnvironmentStorage.getSelectedEnvironment();
    return await CatalogAPI.requestAuthenticated({
      endpoint: `/${environment}/${service}/flat`,
    });
  }

  static async putIfoodCatalog(catalog, service = null) {
    return await CatalogAPI.requestAuthenticated({
      endpoint:
        "/" +
        EnvironmentStorage.getSelectedEnvironment() +
        (service ? "/" + service : "") +
        "/flat",
      method: "put",
      data: catalog,
    });
  }

  static async getCatalogByService(environmentId, service) {
    const environment =
      environmentId || EnvironmentStorage.getSelectedEnvironment();
    return await CatalogAPI.requestAuthenticated({
      service: "catalog2",
      endpoint: `/${environment}/${service}`,
    });
  }

  static async putCatalog(catalog, service = null) {
    return await CatalogAPI.requestAuthenticated({
      service: "catalog2",
      endpoint:
        "/" +
        EnvironmentStorage.getSelectedEnvironment() +
        (service ? "/" + service : ""),
      method: "put",
      data: catalog,
    });
  }

  static async putImportCatalog(merchantId, csvCatalog = "") {
    return await CatalogAPI.requestAuthenticated({
      service: "catalog2",
      endpoint: "/" + EnvironmentStorage.getSelectedEnvironment() + "/ifood",
      method: "put",
      data: { merchantId, csvCatalog },
    });
  }

  static async getDownloadSKU(service) {
    const base_url = process.env.REACT_APP_SERVICES_ENDPOINT_BASE.replace(
      "{SERVICE}",
      "catalog"
    );
    const url = `${base_url}/${EnvironmentStorage.getSelectedEnvironment()}/${service}/export`;
    const response = await axios.request({
      url: url,
      headers: { Authorization: "Bearer " + UserStorage.getAccessToken() },
      responseType: "blob",
    });

    const href = URL.createObjectURL(response.data);
    const link = document.createElement("a");
    link.href = href;

    link.setAttribute("download", `${service}.csv`);
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(href);
  }

  static async postImportSKU(service, csv = "") {
    return await CatalogAPI.requestAuthenticated({
      service: "catalog2",
      endpoint:
        "/" +
        EnvironmentStorage.getSelectedEnvironment() +
        "/" +
        service +
        "/import/sku",
      method: "post",
      data: { csv },
    });
  }

  static async copyCatalog({
    sourceEnvironment,
    sourceService,
    targetEnvironments,
    targetServices,
  }) {
    return await CatalogAPI.requestAuthenticated({
      service: "catalog2",
      endpoint: `/${sourceEnvironment}/${sourceService}/copy`,
      method: "post",
      data: {
        environmentIds: targetEnvironments,
        services: targetServices,
      },
    });
  }

  static async shutdownCatalog({ environmentId, service }) {
    const environment =
      environmentId || EnvironmentStorage.getSelectedEnvironment();

    return await CatalogAPI.requestAuthenticated({
      service: "catalog2",
      endpoint: `/${environment}/${service}/shutdown`,
      method: "post",
    });
  }

  static async importNetLogicCatalog({ environmentId, service, catalog }) {
    const environment =
      environmentId || EnvironmentStorage.getSelectedEnvironment();

    return await CatalogAPI.requestAuthenticated({
      service: "catalog2",
      endpoint: `/${environment}/${service}/netlogic/import`,
      method: "post",
      data: catalog,
    });
  }

  static async getSharedSteps(environmentId) {
    return await CatalogAPI.requestAuthenticated({
      service: "catalog2",
      endpoint: `/${environmentId}/steps`,
      method: "get",
    });
  }

  static async createSharedStep({ environmentId, step }) {
    return await CatalogAPI.requestAuthenticated({
      service: "catalog2",
      endpoint: `/${environmentId}/steps`,
      method: "post",
      data: step,
    });
  }

  static async updateSharedStep({ environmentId, step }) {
    return await CatalogAPI.requestAuthenticated({
      service: "catalog2",
      endpoint: `/${environmentId}/steps/${step.id}`,
      method: "put",
      data: step,
    });
  }

  static async getCatalogLock({ environmentId }) {
    return await CatalogAPI.requestAuthenticated({
      service: "catalog2",
      endpoint: `/${environmentId}/lock`,
      method: "get",
    });
  }
}
